module.exports = __webpack_public_path__ + "static/media/dark-bg.d914334b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dark-bg.jpg
// module id = 179
// module chunks = 38